import React, { useState } from 'react';
import { FieldErrors, useController } from 'react-hook-form';

import {
  formatNumberWithCommas,
  unformatNumber,
} from '../../../../../../../utils/CurrencyUtils';
import { MileageReportRequestUpdate } from '../../SubmitMileage';

interface Props {
  name: string;
  control: any;
  index: number;
  errors?: FieldErrors<{ assets: MileageReportRequestUpdate[] }>;
  defaultValue?: any;
  previousOdometer?: number | null;
  disabled?: boolean;
}

export const MileageInput: React.FC<Props> = ({
  name,
  control,
  index,
  errors,
  defaultValue,
  previousOdometer,
  disabled = false,
}) => {
  const {
    field: { value, onChange, ...rest },
  } = useController({ name, control, defaultValue: defaultValue ?? '' });

  const [validationError, setValidationError] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = unformatNumber(e.target.value);
    const numValue = Number(raw);

    // Validate against previous odometer
    if (
      previousOdometer != null &&
      numValue > 0 &&
      numValue < previousOdometer
    ) {
      setValidationError(
        `Odometer must be at least ${formatNumberWithCommas(previousOdometer)}`
      );
    } else {
      setValidationError(null);
    }

    onChange(numValue);
  };

  const formErrorMessage =
    errors?.assets &&
    Array.isArray(errors.assets) &&
    errors.assets[index]?.cumulative_odometer?.message;

  const hasError = formErrorMessage || validationError;

  return (
    <div>
      <input
        {...rest}
        value={formatNumberWithCommas(value) || ''}
        onChange={handleChange}
        placeholder={disabled ? '' : 'Ex.: 200,000'}
        disabled={disabled}
        className={`mt-1 block w-full border px-3 py-2 ${
          hasError ? 'border-red-500' : 'border-gray-300'
        } ${
          disabled ? 'cursor-not-allowed bg-gray-100 text-gray-500' : 'bg-white'
        } rounded-md shadow-sm focus:border-blue-400 focus:outline-none focus:ring-blue-400 sm:text-sm`}
      />
      {validationError && !disabled && (
        <p className="mt-1 text-sm text-red-500">{validationError}</p>
      )}
      {formErrorMessage && !validationError && !disabled && (
        <p className="mt-1 text-sm text-red-500">{formErrorMessage}</p>
      )}
    </div>
  );
};

export default MileageInput;
